/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import * as tf from "@tensorflow/tfjs";
import RightContent from "./RightContent";
import LeftContent from "./LeftContent";
import Camera from "./Camera";
import { carCount, setCars } from "../Redux/Features/carSlice";
import { setValidation } from "../Redux/Features/modelSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useDidMountEffect from "../CustomHooks/useDidMountEffect";
import axios from "axios";
import { setLoading } from "../Redux/Features/modelSlice";
import Loader from "../Components/Loader";
import Modal from "../Components/Modal";
import Landscape from "./Landscape";
import { networkStatus } from "../services/networkStatusService";
import { DirectionsSubwayFilled } from "@mui/icons-material";
import { getDynamicToken } from "../utils/authUtils";
import { useTelemetry } from "../telemetry/TelemetryProvider";
import { updateClaimStatus } from '../utils/updateClaimStatus';
// ========== CONFIGURATION ==========
const DETECTION_INTERVAL = 1200; // ms between detection attempts (adjustable: 1000-1500ms recommended)
const DOWNSCALE_WIDTH = 1280; // Lower resolution for detection only
const DOWNSCALE_HEIGHT = 720; // Lower resolution for detection only
const DOWNSCALE_QUALITY = 0.8; // JPEG quality for detection (0.7-0.85 recommended)

const Portrait = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [inNetwork, setInNetwork] = useState(true);
    const [retakeValidation, setRetakeValidation] = useState(false);
    const [cameraBlocked, setCameraBlocked] = useState(undefined);
    const [latitude, setLatitude] = useState("19.1624");
    const [longitude, setLongitude] = useState("72.9376");
    const [latency, setLatency] = useState("-- ms");
    const [locationBlocked, setLocationBlocked] = useState(false);

    const isClaim = useSelector((state) => state.isClaim);
    const car = useSelector((state) => state.car);
    const modelWrapper = useSelector((state) => state.model);
    const breakin = useSelector((state) => state.breakin);

    const webcamRef = useRef(null);
    const mainContainerRef = useRef(null);
    const lastNotInNetworkCarCount = useRef(null);
    const validatingRef = useRef(false); // Prevent overlapping API calls

    const isEveryUpload = car.data.every((item) => item.isUpload);
    const isDetected = modelWrapper.validation.length === 8;
    const model = modelWrapper.model;

    const [result, setResult] = useState({});
    const [imgObj, setImgObj] = useState(null);
    const [carDetected, setCarDetected] = useState({
        msg: "Searching For Car",
        value: "S",
    });

    const { track, tSessionId } = useTelemetry();

    // ========== HELPER FUNCTIONS ==========

    /**
     * Downscale image for detection to reduce processing load
     * Uses createImageBitmap to avoid CSP issues with data URLs
     * Original full-res image still used for capture/storage
     */
    const downscaleImage = async (
        base64,
        targetWidth,
        targetHeight,
        quality = 0.8
    ) => {
        try {
            // Convert base64 to blob first (CSP-safe)
            const blob = base64ToBlob(base64);

            // Create ImageBitmap from blob (no CSP issues)
            const imageBitmap = await createImageBitmap(blob);

            // Create canvas and draw downscaled image
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = targetWidth;
            canvas.height = targetHeight;

            // Draw the bitmap onto canvas at reduced size
            ctx.drawImage(imageBitmap, 0, 0, targetWidth, targetHeight);

            // Convert back to base64
            return canvas.toDataURL("image/jpeg", quality);
        } catch (error) {
            console.error("Error downscaling image:", error);
            // Fallback: return original if downscaling fails
            return base64;
        }
    };

    function r(e, t) {
        var i = parseInt(e),
            n = parseInt(t);
        return (
            (isNaN(i) || isNaN(n) ? " " : ((n / i) * 100).toFixed(3)) / 100
        ).toFixed(2);
    }

    function getRndInteger(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    function blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                resolve(base64String);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    function base64ToBlob(base64Image) {
        const parts = base64Image.split(";base64,");
        const contentType = parts[0].split(":")[1];
        const base64String = parts[1];

        const byteCharacters = atob(base64String);
        const byteArrays = [];

        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }

        const byteArray = new Uint8Array(byteArrays);

        return new Blob([byteArray], { type: contentType });
    }

    // ========== CORE DETECTION LOGIC ==========

    async function andy(e, b, a) {
        const functionStart = Date.now();
        //console.log("🔍 andy() called at:", new Date().toISOString());
        let result;
        let x2;
        let y1;
        let y2;
        let score;
        let width;
        let height;
        let t = new FormData();
        let roi_url;

        if (import.meta.env.VITE_IS_PARTIAL_IMAGES_LIVE && isClaim) {
            roi_url = "https://aicamera.dev.camcom.ai/roi-partial-capture";
        } else {
            roi_url = "https://aicamera.camcom.ai/roi-capture";
        }

        //console.log("📡 Calling API:", roi_url);

        t.append("image", e),
            t.append("ref_num", "666"),
            t.append("source_name", "hdfcergo");
        let config = {
            method: "post",
            url: roi_url,
            data: t,
        };
        await axios(config)
            .then(function (e) {
                //console.log("✅ API Response received");
                let o = (x2 = y1 = y2 = score = width = height = 0);

                if (e?.data?.message) {
                    result = { car: false, message: e.data.message, isapimsg: true };
                    const functionEnd = Date.now();
                    setLatency(`${functionEnd - functionStart} ms`);
                } else if (
                    e.data.hasOwnProperty("car_coords") &&
                    e.data.hasOwnProperty("conf_score") &&
                    e.data.hasOwnProperty("final_side")
                ) {
                    try {
                        if (e.data.conf_score) {
                            e.data.conf_score = e.data.conf_score * 100;
                        }
                    } catch (e) { }
                    let i = e.data.car_coords;

                    let o = i[0];
                    let y1 = i[1];
                    let x2 = i[2];
                    let y2 = i[3];
                    let score = e.data.conf_score;
                    let width = x2 - o;
                    let height = y2 - y1;

                    function Details(e, t, i, n, a, o, c, d) {
                        let p = (c - a) / 2;
                        let s = (d - o) / 2;
                        let h = 0;
                        let v_p = 0;
                        let d_p = 0;
                        let m = !0;
                        let tvv;
                        let vmp;
                        let diff;
                        e < 0 && ((e = 0), (m = !1));
                        t < 0 && ((t = 0), (m = !1));
                        i > c && ((i = width), (m = !1));
                        n > d && ((n = height), (m = !1));
                        var f = r(p, e),
                            l = (r(p, c - i), r(s, t), r(s, d - n), (tvv = 0)),
                            _ = (vmp = 1);
                        e == p || (e > p ? (l = e - p) : ((l = p - e), (_ = -1)));
                        t == s || (t > s ? (tvv = t - s) : ((tvv = s - t), (vmp = -1)));
                        let u = r(c, l),
                            g = r(d, tvv);
                        (h = parseInt(10 * u) * _),
                            (v_p = parseInt(10 * g) * vmp),
                            (diff = 100 * r(c * d, a * o)),
                            f < 0 && (f = 0);
                        diff >= 98 && (d_p = 1);
                        diff <= 40 && (d_p = -1);

                        return {
                            h_precision: h,
                            v_precision: v_p,
                            d_precision: d_p,
                            car_in_frame: m,
                        };
                    }
                    let data =
                        score > 0 &&
                        e.data.final_side &&
                        Details(o, y1, x2, y2, width, height, b, a);

                    let car = score > 0;

                    const functionEnd = Date.now();
                    setLatency(`${functionEnd - functionStart} ms`);

                    result = {
                        ...data,
                        o,
                        y1,
                        x2,
                        y2,
                        car,
                        coord: e.data.car_coords,
                        confidence: score,
                        message: e.data.message,
                        final_side: e.data.final_side,
                    };
                } else {
                    result = { car: false, message: e.message };
                }
            })
            .catch(function (error) {
                console.error("❌ API Error:", error);
                const functionEnd = Date.now();
                setLatency(`${functionEnd - functionStart} ms`);
            });

        let tempData = JSON.parse(JSON.stringify(car.data));
        const detection = result.car;
        const carInFrame = result.car_in_frame;
        const d_precision = result.d_precision;
        const h_precision = result.h_precision;
        const v_precision = result.v_precision;
        const final_side = result.final_side;
        var newStr = tempData[car.count - 1].imgId.replace(/_/g, "");

        if (newStr == "PartialRearLeft") {
            newStr = "left_rear";
        } else if (newStr == "PartialFrontLeft") {
            newStr = "left_front";
        } else if (newStr == "PartialFrontRight") {
            newStr = "right_front";
        } else if (newStr == "PartialRearRight") {
            newStr = "right_rear";
        }

        if (result?.isapimsg == true) {
            setCarDetected({
                msg: result.message,
                value: "ND",
            });
        } else {
            setCarDetected({
                msg: detection
                    ? result.confidence < 10
                        ? "Car Not Detected"
                        : newStr !== final_side
                            ? `Wrong Angle`
                            : result.confidence < 50
                                ? !carInFrame
                                    ? `Car not in Frame`
                                    : d_precision < 0
                                        ? "Too far, please take a step forward."
                                        : d_precision > 0
                                            ? "Too close, please take a step back."
                                            : h_precision <= -2
                                                ? "Too Left, please move to right "
                                                : h_precision >= 2
                                                    ? "Too Right, please move to left"
                                                    : v_precision <= -2
                                                        ? "Too Up, please hold down"
                                                        : v_precision >= 2
                                                            ? "Too Down, please hold up"
                                                            : `Low Accuracy ${Math.round(result.confidence)}`
                                : result.confidence > 50 &&
                                `Car Detected ${final_side} with accuracy ${Math.round(
                                    result.confidence
                                )} `
                    : "Searching For Car",
                value: detection
                    ? result.confidence < 10
                        ? "ND"
                        : result.confidence > 50 && newStr === final_side
                            ? "D"
                            : (newStr !== final_side ||
                                !carInFrame ||
                                (d_precision < 0 && d_precision > 0) ||
                                (h_precision <= -2 && h_precision >= -2) ||
                                (h_precision <= -2 && h_precision >= -2) ||
                                result.confidence < 50) &&
                            "M"
                    : "S",
            });
        }

        return result;
    }

    // ========== OUT OF NETWORK HANDLING ==========

    const handleOutOfNetwork = (currentCarCount) => {
        if (lastNotInNetworkCarCount.current === currentCarCount) return;

        setCarDetected({
            msg: "You're in a low network zone.",
            value: "D",
        });

        setResult({
            o: null,
            y1: null,
            x2: null,
            y2: null,
            car: true,
            coord: [0, 0, 0, 0],
            confidence: 96.69,
            message: "Not in network",
            final_side: "nothing",
        });

        lastNotInNetworkCarCount.current = currentCarCount;
    };

    // ========== CONTINUOUS DETECTION LOOP (FIXED - NO MORE DEPENDENCY ON result) ==========

    useEffect(() => {
        //console.log("🔄 Detection useEffect triggered. cameraBlocked:", cameraBlocked, "car.count:", car.count);

        if (cameraBlocked) {
            //console.log("⚠️ Camera blocked, skipping detection");
            return;
        }

        const isPartialImagesLive =
            Number(import.meta.env.VITE_IS_PARTIAL_IMAGES_LIVE || "0") === 1;
        const carLimit = isClaim && isPartialImagesLive ? 10 : 8;

        if (car.count > carLimit) {
            //console.log("⚠️ Car limit reached, skipping detection");
            return;
        }

        if (!inNetwork) {
            console.log("⚠️ Out of network");
            handleOutOfNetwork(car.count);
            return;
        }

        const validateFrame = async () => {
            // Skip if previous call still running (prevents request stacking)
            if (validatingRef.current) {
                console.log("⏭️ Skipping - previous validation still running");
                return;
            }

            const shot = webcamRef.current?.getScreenshot?.();
            if (!shot) {
                console.log("⚠️ No screenshot available");
                return;
            }

            //console.log("📸 Screenshot captured, processing...");

            validatingRef.current = true;
            try {
                // ✅ OPTIMIZATION: Downscale image for detection only
                const downscaled = await downscaleImage(
                    shot,
                    DOWNSCALE_WIDTH,
                    DOWNSCALE_HEIGHT,
                    DOWNSCALE_QUALITY
                );

                //console.log("🔽 Image downscaled, calling API...");

                const blob = base64ToBlob(downscaled);
                const res = await andy(
                    blob,
                    DOWNSCALE_WIDTH, // Use downscaled dimensions
                    DOWNSCALE_HEIGHT
                );
                setResult(res);
                //console.log("✅ Result set:", res);
            } catch (error) {
                console.error("❌ Detection error:", error);
            } finally {
                validatingRef.current = false;
            }
        };

        // Start interval
        //console.log("▶️ Starting detection interval with", DETECTION_INTERVAL, "ms delay");
        const intervalId = setInterval(validateFrame, DETECTION_INTERVAL);

        return () => {
            //console.log("🛑 Cleaning up interval");
            clearInterval(intervalId);
        };

        // ✅ CRITICAL FIX: Removed 'result' from dependencies - this was the main bug!
    }, [car.count, cameraBlocked, inNetwork]);

    // ========== NAVIGATION LOGIC ==========

    useDidMountEffect(() => {
        if (isEveryUpload) {
            navigate("/upload");
        }
    }, [car]);

    // ========== LOCATION TRACKING ==========

    useEffect(() => {
        let watchId;

        const fetchLocation = async () => {
            try {
                watchId = navigator.geolocation.watchPosition(
                    async (position) => {
                        setLocationBlocked(false);
                        setLatitude(position.coords.latitude);
                        setLongitude(position.coords.longitude);
                    },
                    async (error) => {
                        console.error("Error getting current position:", error);
                        try {
                            const result = await navigator.permissions.query({
                                name: "geolocation",
                            });
                            if (result.state === "granted") {
                                setLocationBlocked(false);
                                setLatitude("19.1624");
                                setLongitude("72.9376");
                            } else {
                                setLocationBlocked(true);
                            }
                        } catch (error) {
                            console.error("Error querying geolocation permission:", error);
                        }
                    },
                    { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
                );
            } catch (error) {
                console.error("Error getting current position:", error);
            }
        };

        fetchLocation();

        return () => {
            if (watchId) {
                navigator.geolocation.clearWatch(watchId);
            }
        };
    }, []);

    // ========== NETWORK STATUS CHECK ==========

    useEffect(() => {
        const checkNetwork = async () => {
            try {
                const now = Date.now();
                const lastCheck = localStorage.getItem("last_health_check");

                // If last check was within 60 seconds, skip API call
                if (lastCheck && now - parseInt(lastCheck, 10) < 120000) {
                    setInNetwork(true);
                } else {
                    const dynamicToken = await getDynamicToken();
                    // console.log(dynamicToken);
                    const status = await networkStatus(
                        `${import.meta.env.VITE_API_URL}/api-health`,
                        dynamicToken,
                        3
                    );
                    localStorage.setItem("last_health_check", now.toString());
                    setInNetwork(status);
                }
            } catch (error) {
                console.error("Error checking network status:", error);
                setInNetwork(false);
            }
        };

        checkNetwork();
    }, []);

    // ========== CAPTURE LOGIC ==========

    const convertToBlob = (dataUrl) => {
        if (!dataUrl) return null;
        if (typeof dataUrl !== "string") return dataUrl;

        if (
            dataUrl.startsWith("blob:") ||
            dataUrl.startsWith("http://") ||
            dataUrl.startsWith("https://") ||
            dataUrl.startsWith("/")
        ) {
            return dataUrl;
        }

        if (dataUrl.startsWith("data:")) {
            try {
                const parts = dataUrl.split(",");
                if (parts.length !== 2) throw new Error("Invalid data URL format");
                const header = parts[0];
                const data = parts[1];
                let mimeType = "application/octet-stream";
                const mimeMatch = header.match(/data:([^;]+)/);
                if (mimeMatch) mimeType = mimeMatch[1];
                const binaryString = atob(data);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++)
                    bytes[i] = binaryString.charCodeAt(i);
                const blob = new Blob([bytes], { type: mimeType });
                return URL.createObjectURL(blob);
            } catch (error) {
                console.error("Error converting data URL to blob:", error);
                return null;
            }
        }
        return dataUrl;
    };

    const capture = async () => {
        let imageSrc = webcamRef.current.getScreenshot();

        const img = new Image();
        img.src = convertToBlob(imageSrc);
        img.onload = () => {
            const originalWidth = img.width;
            const originalHeight = img.height;

            const targetWidth = 1024;
            const targetHeight = 768;

            // Only resize if smaller than 1024×768
            if (originalWidth < targetWidth || originalHeight < targetHeight) {
                const canvas = document.createElement("canvas");
                canvas.width = targetWidth;
                canvas.height = targetHeight;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

                imageSrc = canvas.toDataURL("image/jpeg", 1.0);
            }

            let tempData = JSON.parse(JSON.stringify(car.data));
            const foundIndex = tempData.findIndex(
                (e) => Number(e.key) === Number(car.count)
            );

            if (foundIndex > -1) {
                tempData[foundIndex].isUploadImg = imageSrc;
                tempData[foundIndex].isUpload = true;
                tempData[foundIndex].isUploadBlob = convertToBlob(imageSrc);
                tempData[foundIndex].latitude = latitude;
                tempData[foundIndex].longitude = longitude;
                track('IMAGE_CAPTURED', { sequenceNo: car.count, docName: car.data[car.count - 1].imgId });
                // console.log("Capturing image for car count:", car.count);
                if (car.count == 1) {
                    updateClaimStatus('FIRST_IMAGE_CLICKED');
                }
                // First increment the count
                if (!isEveryUpload) {
                    dispatch(carCount());
                }

                // Update car data
                tempData[foundIndex].isActive = false;
                if (foundIndex < car.checkCount) {
                    tempData[foundIndex + 1].isActive = true;
                }
                dispatch(setCars(tempData));

                // Handle validation
                if (tempData[foundIndex].toValidate) {
                    console.log(result);
                    dispatch(setValidation({ result, key: car.count }));
                }

                // Reset detection state
                setResult({});
                setCarDetected({
                    msg: "Searching For Car",
                    value: "S",
                });
            }
        };
    };

    // ========== CAMERA INITIALIZATION ==========

    const startObjectDetection = () => {
        //console.log("📹 Camera initialized");
        setCameraBlocked(false);
        webcamRef.current.video.onplaying = () => {
            //console.log("🎬 Video playing - running initial detection");
            let t = document.createElement("canvas");
            const video = webcamRef.current.video;
            const ctx = t.getContext("2d");

            ctx.canvas.width = video.videoWidth;
            ctx.canvas.height = video.videoHeight;
            ctx.drawImage(video, 0, 0);

            t.toBlob((blob) => {
                andy(blob, video.videoWidth, video.videoHeight).then(setResult);
            }, "image/jpeg");
        };
    };

    const cameraBlock = (value) => {
        setCameraBlocked(value);
    };

    // ========== RENDER ==========

    return (
        <>
            <div ref={mainContainerRef} className="main_container">
                <div className="left_content">
                    <LeftContent />
                </div>
                <div className="center_content">
                    <Camera
                        ref={webcamRef}
                        detection={carDetected}
                        result={result}
                        startObjectDetection={startObjectDetection}
                        cameraBlock={cameraBlock}
                        latency={latency}
                    />
                </div>
                <div className="right_content">
                    <RightContent mainContainerRef={mainContainerRef} capture={capture} />
                </div>
            </div>
            {loading && (
                <Modal>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100vh",
                            margin: "0 20px",
                        }}
                    >
                        <span
                            className="please_wait"
                            style={{ color: "white", fontSize: "20px" }}
                        >
                            Please wait...
                        </span>
                    </div>
                </Modal>
            )}

            {locationBlocked && (
                <Modal>
                    <div className="modalContainer">
                        <div className="retake_modal">
                            <span>
                                Please allow location access from your browser and refresh.
                            </span>
                            <div className="yes_no_btn">
                                <button
                                    style={{ backgroundColor: "#e42125" }}
                                    onClick={() => window.location.reload()}
                                >
                                    Refresh
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default Portrait;
